
interface LogoProps {
  className?: string;
}

export default function Logo({ className = "h-12 w-auto" }: LogoProps) {
  return (
    <img
      src="/logo2.png"
      alt="Sistema Parecer Descomplicado com IA"
      className={className}
    />
  );
}
